export type { TopLegendFormatterType } from './TopLegend';
export { default } from './TopLegend';
